import React from 'react';
import {
  FormattedNamesDTO,
  UserDTO,
} from 'dtos';
import {
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import Name from 'pages/Dashboard/components/Name';
import {
  ImageSize,
} from 'pages/Dashboard/components/Image';
import {
  useProfilePicture,
} from 'pages/Dashboard/hooks/media';

export type UserNameProps = {
  user?: UserDTO | null;
  formattedNames?: FormattedNamesDTO | null;
  className?: string;
  labelClassName?: string;
  size?: ImageSize;
  variant?: 'circular' | 'rounded';
};

export default function UserName({
  user,
  formattedNames,
  className = 'font-semibold',
  labelClassName,
  size = 'sm',
  variant = 'rounded',
}: UserNameProps) {
  const userId = user?.userId ?? 0;
  const { src } = useProfilePicture(userId, MediaOriginatorType.User);
  const names = formattedNames ?? user?.formattedNames;

  return (
    <Name
      image={{
        size,
        variant,
        src,
      }}
      {...names}
      className={className}
      labelClassName={labelClassName}
    />
  );
}
